<div [formGroup]="tenantRelationFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="grid">

    <ng-container *ngIf="headline && !slimmedView">
        <div fxFlex=100>
            <h2>{{ headline }}</h2>
        </div>
    </ng-container>

    <ng-container *ngIf="topList?.length || bottomList?.length">
        <div fxFlex="100">
            <ng-container *ngIf="multipleSelectable">
                <div class="mb-16">
                    <mat-button-toggle-group name="options"
                                             [(ngModel)]="selectedFilterOption"
                                             (ngModelChange)="saveSelectedFilterOption($event)"
                                             [ngModelOptions]="{standalone: true}">
                        <mat-button-toggle *ngFor="let option of filterOptions" [value]="option">
                            {{ 'bcmTenantRelations.widget.optionSearch' | translate: { option: option } }}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>{{ label }}</mat-label>
                    <u2b-chip-list-input formControlName="tenantRelations"
                                         [hasRemove]="true"
                                         [selectedFilterOption]="selectedFilterOption"
                                         [dataObservable]="tenantRelationsApiService.select()"
                                         [disableConditionCallback]="disableConditionCallback"></u2b-chip-list-input>
                    <mat-error>{{ tenantRelationFormGroup.get('tenantRelations').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="!multipleSelectable">
                <mat-form-field fxFlex [appearance]="appearance" floatLabel="always">
                    <mat-label>{{ 'workflows.formWidgets.tenantRelation.relationLabel' | translate }}</mat-label>
                    <input type="text" matInput data-test="FI-Nach Beziehung suchen..."
                           formControlName="tenantRelation"
                           [matAutocomplete]="tenantRelationSelector">
                        <button matSuffix
                                mat-icon-button
                                type="button"
                                color="warn"
                                [matTooltip]="'bcmTenantRelations.widget.removeSelected' | translate"
                                [disabled]="!selectTenantRelation?.id || parentFormGroup.disabled || readonly"
                                (click)="removeTenantRelation()">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    <mat-error
                            [hidden]="slimmedView">{{ tenantRelationFormGroup.get('tenantRelation').errors | firstErrorMessage }}
                    </mat-error>
                </mat-form-field>

                <mat-autocomplete #tenantRelationSelector="matAutocomplete"
                                  [displayWith]="displayTenantRelationWith">
                    <ng-container *ngIf="personOrCompanyName">
                        <ng-container *ngIf="filteredTopList$ | async as topList">
                            <mat-optgroup [label]="'bcmTenantRelations.widget.relationsOf' | translate: { name: personOrCompanyName }">
                                <ng-container *ngFor="let tenantRelation of topList">
                                    <mat-option [value]="tenantRelation">
                                        {{ tenantRelation.name }}
                                    </mat-option>
                                    <ng-container *ngIf="!topList?.length">
                                        {{ 'bcmTenantRelations.widget.noRelationForEntity' | translate: { name: personOrCompanyName } }}
                                    </ng-container>
                                </ng-container>
                            </mat-optgroup>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="filteredBottomList$ | async as bottomList">
                        <mat-optgroup [label]="(personOrCompanyName ? 'bcmTenantRelations.widget.moreRelations' : 'bcmTenantRelations.widget.allRelations') | translate">
                            <ng-container *ngFor="let tenantRelation of bottomList">
                                <mat-option [value]="tenantRelation" [disabled]="disableOtherRelations">
                                    {{ tenantRelation.name }}
                                </mat-option>
                                <ng-container *ngIf="!bottomList?.length">
                                    {{ 'bcmTenantRelations.widget.noRelationsFound' | translate }}
                                </ng-container>
                            </ng-container>
                        </mat-optgroup>
                    </ng-container>
                </mat-autocomplete>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="!slimmedView && (selectedTenantRelations$ | async) as selectedTenantRelations">
        <ng-container *ngIf="selectedTenantRelations?.length">
            <div fxFlex="100" class="mb-16">
                <table class="simple sm not-striped">
                    <thead>
                    <tr>
                        <th>{{ 'table.product' | translate }}</th>
                        <th style="width: 80px;" class="text-center">{{ 'common.quantity' | translate }}</th>
                        <th class="text-right">
                            {{ 'table.singlePrice' | translate }}
                            <ng-container
                                    *ngIf="(selectedTenantRelationPayableOption$ | async)?.translationKey as payableOptionKey">
                                <br>
                                <small>({{ payableOptionKey | translate }})</small>
                            </ng-container>
                        </th>
                        <th class="text-right">{{ 'common.total' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let tenantRelation of selectedTenantRelations; let i = index">
                        <tr class="with-background">
                            <td colspan="4">{{ tenantRelation.name }}</td>
                        </tr>
                        <ng-container *ngFor="let product of tenantRelation.products">
                            <tr>
                                <td>{{ product.name }}</td>
                                <td style="width: 80px;" class="text-center">
                                    {{ product.quantity }}
                                </td>
                                <td class="text-right">
                                    {{ (product.dynamicPrice?.rulePrice != null ? product.dynamicPrice.rulePrice : product.price) | bcmDynamicCurrency: '1.2-2' }}
                                </td>
                                <td class="text-right">
                                    {{ (product.quantity || 0) * (product.dynamicPrice?.rulePrice != null ? product.dynamicPrice.rulePrice : (product.price || 0)) | bcmDynamicCurrency: '1.2-2' }}
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3" class="no-border"></td>
                        <td class="text-right padding sum">
                            {{ selectedTenantRelationProductPriceTotal$ | async | bcmDynamicCurrency: '1.2-2' }}
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </ng-container>
    </ng-container>

</div>
